/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import { Alert } from "components/Varios/Alert.js";

import { authenticationService } from '../services/authentication.service';

import DOCTOR_ROUTES from "../components/Doctor/RutasDoctor";


import Sidebar_Principal from "components/Sidebar/Sidebar_Principal";

// Para efectos
import { Transition } from 'react-transition-group'
import PlanificacionVacaciones from "components/DirectivoUnidad/Vacaciones/PlanificacionVacaciones";
import ModalActualizarDatosPers from "components/Varios/ModalActualizarDatosPers";
import { detectResize } from "./functionsLayout";
import ModalTiempoSesion from "components/Varios/ModalTiempoSesion";
class DoctorLayout extends React.Component {

    timeout: NodeJS.Timeout | null = null;

    state = {
        currentUser: authenticationService.currentUserValue,
        openSideBar: true,
        showModalCambios: true,
        showModalSession: false
    };

    callBackStateResize = () => {
        this.setState({ openSideBar: true })
    }


    handleVisibilityChange = () => {
        // No action needed when visibility changes
        // The timeout will continue running regardless of visibility state
    }

    isSessionActive = () => {
        const tiempoExpiraSesion = new Date(authenticationService.currentUserValue.fechaHoraSesionActiva ?? new Date());
        const fechaActual = new Date(authenticationService.currentUserValue.fechaHoraSesionComparar ?? new Date());

        var fechaActualizado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), fechaActual.getHours(), fechaActual.getMinutes(), fechaActual.getSeconds() + 23)

        if (document.visibilityState === 'hidden') {
            // Browser window is minimized or tab is switched
            fechaActualizado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), fechaActual.getHours(), fechaActual.getMinutes(), fechaActual.getSeconds() + 27)
        }
        authenticationService.UpdateSessionCompareTime(fechaActualizado);


        if (tiempoExpiraSesion.getTime() > fechaActualizado.getTime()) {
            ;

        }
        else {

            this.setState({ showModalSession: true });
        }
        this.runFunction();
    };

    runFunction = () => {
        // Use setTimeout instead of setInterval
        // This ensures that the function is called after a delay
        // even if the browser window is minimized
        this.timeout = setTimeout(this.isSessionActive, 20000); // Example: 1 second delay
    }

    componentDidMount() {
        this.setState({ currentUser: authenticationService.currentUserValue })
        window.addEventListener("resize", () => detectResize(this.callBackStateResize));
        document.addEventListener("visibilitychange", this.handleVisibilityChange);

        // this.timeout  = setTimeout(this.isSessionActive, 2000);
        this.runFunction()
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.callBackStateResize);
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

    }


    logout() {
        // authenticationService.logout();
    }

    render() {
        return this.renderPage();
    }

    renderPage() {
        const layout_route = "/doctor";
        return (
            <React.Fragment>
                <DemoNavbar {...this.props} />


                <div className="parent_supremo">

                    <div className="parent_contenido_pantalla">
                        {/* {this.state.currentUser !== null && this.state.currentUser.idpersona !== 0 ? <Sidebar_Principal /> : ""} */}
                        <div className="btn_mostrar_barra" onClick={() => this.setState({ openSideBar: !this.state.openSideBar })}> <i className="fas fa-solid fa-bars" ></i> </div>
                        <Transition
                            in={this.state.openSideBar}
                            timeout={400}
                            unmountOnExit
                            mountOnEnter
                        >
                            {state => (

                                <Sidebar_Principal onClickOverlay={() => this.setState({ openSideBar: false })} />
                            )}
                        </Transition>
                        <div className="main-panel" id="main-panel" >
                            <Alert />
                            <Switch>

                                {DOCTOR_ROUTES.map((prop, key) => {

                                    return (
                                        <Route
                                            path={prop.layout + prop.path}
                                            component={prop.component}

                                            key={key}
                                        />

                                    );
                                })}






                            </Switch>
                            <ModalActualizarDatosPers
                                show={this.state.currentUser.ultimoCambio !== undefined && this.state.currentUser.token !== undefined && this.state.currentUser.showModalActualizarDP && this.state.showModalCambios}
                                fechaActualizacion={this.state.currentUser.ultimoCambioDatosPersonales}
                                tokenUser={this.state.currentUser.token}
                                onClose={() => this.setState({ showModalCambios: false })}

                            />

                            <ModalTiempoSesion
                                show={this.state.showModalSession}
                                tokenUser={authenticationService.currentUserValue.token}
                                onClose={() => { this.setState({ showModalSession: false }) }}
                            />

                        </div>
                    </div>

                    <Footer fluid />

                </div>
            </React.Fragment>
        );
    }
}

export default DoctorLayout;
